import { useState } from "react";
import { AuthContext } from ".";
import { useNavigate } from "react-router-dom";

const AuthContextProvider = ({ children }: { children: React.ReactNode }) => {

  const navigate = useNavigate()

  const [user, setUser] = useState<string | undefined>(undefined)
  const [name, setName] = useState<string | undefined>(undefined)
  const [token, setToken] = useState<string | undefined>(undefined)
  const [isPlay, setIsPlay] = useState(false)

  const setPlaygroundHandler = (val: boolean) => {
    setIsPlay(val)
  }

  const logoutHandler = () => {
    setUser(undefined);
    setToken(undefined)
    setName(undefined)
    localStorage.removeItem("loginTime");
    navigate('/', { replace: true })
  }

  const loginHandler = (user: string, token: string, name: string) => {
    console.log("onlogin called")
    setUser(user);
    setToken(token)
    setName(name)
    const now = new Date().getTime(); // Timestamp in ms
    localStorage.setItem("loginTime", now.toString());
  }

  return (
    <AuthContext.Provider value={{
      username: user,
      token: token,
      name: name,
      isPlayground: isPlay,
      setPlaygorund: setPlaygroundHandler,
      onLogin: loginHandler,
      onLogout: logoutHandler
    }}>{children}</AuthContext.Provider>
  )
}

export default AuthContextProvider;
